import { createRoute } from '@tanstack/react-router';

import { AccessGuard } from 'src/guards/AccessGuard';
import { AuthGuard } from 'src/guards/AuthGuard';
import { NotFoundFeature } from 'src/pages/errors/NotFoundFeature';
import { PreferencesDefaultPage } from 'src/pages/preferences/PreferencesDefaultPage';
import { PreferencesPage } from 'src/pages/preferences/PreferencesPage';
import { RootRoute } from 'src/routes/__root';

export const PreferencesRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: '/preferences',
  component: () => (
    <AuthGuard>
      <AccessGuard>
        <PreferencesPage />
      </AccessGuard>
    </AuthGuard>
  ),
  notFoundComponent: () => (
    <NotFoundFeature
      route='/preferences'
      routeTitleKey='Go to the preferences page'
    />
  ),
});

export const PreferencesDefaultRoute = createRoute({
  getParentRoute: () => PreferencesRoute,
  path: '/',
  component: PreferencesDefaultPage,
});
